module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group form-material floating inp-error-marker my-custom-input",
    class: {
      'has-error': _vm.showError
    }
  }, [_c('input', {
    staticClass: "form-control",
    class: {
      error: _vm.showError,
      filled: _vm.hasValue,
      disabled: _vm.disabled
    },
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "type": _vm.type,
      "min": _vm.min,
      "pattern": _vm.pattern,
      "autocomplete": "off",
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "placeholder": _vm.placeholder,
      "name": _vm.label
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      },
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('enterClicked', $event)
      }, function($event) {
        return _vm.$emit('keyup', $event.target.value)
      }],
      "focus": function($event) {
        return _vm.$emit('focus')
      },
      "blur": function($event) {
        return _vm.$emit('blur')
      },
      "keydown": function($event) {
        return _vm.$emit('keydown', $event)
      },
      "keypress": function($event) {
        return _vm.$emit('keypress', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "floating-label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('span', {
    staticClass: "icon-input-error"
  }), _vm._v(" "), (_vm.required) ? _c('label', {
    staticClass: "requred-input-indicator"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), (_vm.showError) ? _c('label', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-303eb470!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/v-components/input-text.vue
// module id = 107
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 29 30 31 32 34 36 37 38 39 40